const STATUSES = {
  created: {
    name: "criado",
    color: "primary"
  },
  completed: {
    name: "completo",
    color: "success"
  },
  reversed: {
    name: "revertido",
    color: "deep-orange"
  },
  failed: {
    name: "falhou",
    color: "accent"
  },
  requested: {
    name: "requisitado",
    color: "grey"
  }
};

export default {
  filters: {
    getTransferStatus(status, field) {
      return STATUSES[status] ? STATUSES[status][field] : "";
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/transferMixin.js